import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
Vue.use(VueRouter)
const routes = [
  {
    path: '/donate',
    name: 'donate',
    component: () => import('@/views/donate.vue')
  },
  {
    path: '/msconsignmentindex',
    name: 'msconsignmentindex',
    component: () => import('@/views/msconsignmentindex.vue')
  },
  {
    path: '/msconsignments',
    name: 'msconsignments',
    component: () => import('@/views/management/msconsignments.vue')
  },
  {
    path: '/eqconsignments',
    name: 'eqconsignments',
    component: () => import('@/views/management/eqconsignments.vue')
  },
  {
    path: '/msconsignmentinfo',
    name: 'msconsignmentinfo',
    component: () => import('@/views/msconsignmentinfo.vue')
  },
  {
    path: '/createmsconsignment',
    name: 'createmsconsignment',
    component: () => import('@/views/management/createmsconsignment.vue')
  },
  {
    path: '/createeqconsignment',
    name: 'createeqconsignment',
    component: () => import('@/views/management/createeqconsignment.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/userinfo',
    name: 'userinfo',
    component: () => import('@/views/userinfo.vue')
  },
  {
    path: '/cooperation',
    name: 'cooperation',
    component: () => import('@/views/cooperationcenter.vue')
  },
  {
    path: '/cooperationinfo',
    name: 'cooperationinfo',
    component: () => import('@/views/cooperationinfo.vue')
  },
  {
    path: '/gamelogs',
    name: 'gamelogs',
    component: () => import('@/views/gamelogs.vue')
  },
  {
    path: '/outfitmgrcenter',
    name: 'outfitmgrcenter',
    component: () => import('@/views/managercenter/outfitmgrcenter.vue')
  },
  {
    path: '/crossserverindex',
    name: 'crossserverindex',
    component: () => import('@/views/crossserverindex.vue')
  },
  {
    path: '/crossservermgr',
    name: 'crossservermgr',
    component: () => import('@/views/managercenter/crossservermgr.vue')
  },
  {
    path: '/goodspricemgr',
    name: 'goodspricemgr',
    component: () => import('@/views/managercenter/goodspricemgr.vue')
  },
  {
    path: '/combatchartmgr',
    name: 'combatchartmgr',
    component: () => import('@/views/managercenter/combatchartmgr.vue')
  },
  {
    path: '/commercialindex',
    name: 'commercialindex',
    component: () => import('@/views/commercialindex.vue')
  },
  {
    path: '/commercialinfo',
    name: 'commercialinfo',
    component: () => import('@/views/commercialinfo.vue')
  },
  {
    path: '/outfitinfo',
    name: 'outfitinfo',
    component: () => import('@/views/outfitinfo.vue')
  },
  {
    path: '/outfitmgr',
    name: 'outfitmgr',
    component: () => import('@/views/managercenter/outfitmgr.vue')
  },
  {
    path: '/commercialmembermgr',
    name: 'commercialmembermgr',
    component: () => import('@/views/managercenter/commercialmembermgr.vue')
  },

  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index.vue')
  },
  {
    path: '/gossipindex',
    name: 'gossipindex',
    component: () => import('@/views/gossipindex.vue')
  },
  {
    path: '/recreationindex',
    name: 'recreationindex',
    component: () => import('@/views/recreationindex.vue')
  },
  {
    path: '/gamedataindex',
    name: 'gamedataindex',
    component: () => import('@/views/gamedataindex.vue')
  },
  {
    path: '/rentindex',
    name: 'rentindex',
    component: () => import('@/views/rentindex.vue')
  },
  {
    path: '/taskindex',
    name: 'taskindex',
    component: () => import('@/views/taskindex.vue')
  },
  {
    path: '/equipmentindex',
    name: 'equipmentindex',
    component: () => import('@/views/equipmentindex.vue')
  },
  {
    path: '/eqconsignmentinfo',
    name: 'eqconsignmentinfo',
    component: () => import('@/views/eqconsignmentinfo.vue')
  },
  {
    path: '/goodspriceindex',
    name: 'goodspriceindex',
    component: () => import('@/views/goodspriceindex.vue')
  },
  {
    path: '/rankinglistindex',
    name: 'rankinglistindex',
    component: () => import('@/views/rankinglistindex.vue')
  },
  {
    path: '/collections',
    name: 'collections',
    component: () => import('@/views/management/collections.vue')
  },
  {
    path: '/goods',
    name: 'goods',
    component: () => import('@/views/management/goods.vue')
  },
  {
    path: '/gossips',
    name: 'gossips',
    component: () => import('@/views/management/gossips.vue')
  },
  {
    path: '/gamedatas',
    name: 'gamedatas',
    component: () => import('@/views/management/gamedatas.vue')
  },
  {
    path: '/rents',
    name: 'rents',
    component: () => import('@/views/management/rents.vue')
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('@/views/management/tasks.vue')
  },
  {
    path: '/goodsinfo',
    name: 'goodsinfo',
    component: () => import('@/views/goodsInfo.vue')
  },
  {
    path: '/gossipinfo',
    name: 'gossipinfo',
    component: () => import('@/views/gossipInfo.vue')
  },
  {
    path: '/recreationinfo',
    name: 'recreationinfo',
    component: () => import('@/views/recreationinfo.vue')
  },
  {
    path: '/gamedatainfo',
    name: 'gamedatainfo',
    component: () => import('@/views/gamedatainfo.vue')
  },
  {
    path: '/rentinfo',
    name: 'rentinfo',
    component: () => import('@/views/rentinfo.vue')
  },
  {
    path: '/taskinfo',
    name: 'taskinfo',
    component: () => import('@/views/taskinfo.vue')
  },
  {
    path: '/creategoods',
    name: 'creategoods',
    component: () => import('@/views/management/creategoods.vue')
  },
  {
    path: '/creategossip',
    name: 'creategossip',
    component: () => import('@/views/management/creategossip.vue')
  },
  {
    path: '/creategamedata',
    name: 'creategamedata',
    component: () => import('@/views/management/creategamedata.vue')
  },
  {
    path: '/createrent',
    name: 'createrent',
    component: () => import('@/views/management/createrent.vue')
  },
  {
    path: '/createtask',
    name: 'createtask',
    component: () => import('@/views/management/createtask.vue')
  },
  {
    path: '/usercenter',
    name: 'usercenter',
    component: () => import('@/views/usercenter.vue'),
    redirect: '/usercenter/mycollections',
    children: [
      {
        path: 'mycollections',
        name: 'mycollections',
        component: () => import('@/views/usercenter/collections.vue')
      },
      {
        path: 'mygoods',
        name: 'mygoods',
        component: () => import('@/views/usercenter/goods.vue')
      },
      {
        path: 'mymsconsigements',
        name: 'mymsconsigements',
        component: () => import('@/views/usercenter/msconsigements.vue')
      },
      {
        path: 'myeqconsignments',
        name: 'myeqconsignments',
        component: () => import('@/views/usercenter/eqconsignments.vue')
      },
      {
        path: 'mytasks',
        name: 'mytasks',
        component: () => import('@/views/usercenter/tasks.vue')
      },
      {
        path: 'mygossips',
        name: 'mygossips',
        component: () => import('@/views/usercenter/gossips.vue')
      },
      {
        path: 'myrents',
        name: 'myrents',
        component: () => import('@/views/usercenter/rents.vue')
      },
      {
        path: 'mygamedatas',
        name: 'mygamedatas',
        component: () => import('@/views/usercenter/gamedatas.vue')
      }
    ]
  }
]

const router = new VueRouter({
  routes
})
// 需要鉴权的页面路径
const authUrls = ['/usercenter', '/creategoods', '/collections', '/usercenter/mygoods', '/usercenter/mycollections', '/usercenter/mytasks',
  '/usercenter/mygossips', '/usercenter/myrents', '/usercenter/mymaterials', '/creategossip', '/gossips', '/goods'
]
// to:到哪里去
// from:从哪里来
// next()是否放行,放行到to要去的路径 next(路径) 进行拦截，并next到里面配置的路径
router.beforeEach((to, from, next) => {
  if (!authUrls.includes(to.path)) {
    // 非权限页面，直接放行，并跳转到对应页面，并终止执行
    if (from.query.indexPageNo != null) {
      store.commit('pagehistory/setIndexPageNo', from.query.indexPageNo)
    }
    if (from.query.taskPageNo != null) {
      store.commit('pagehistory/setTaskPageNo', from.query.taskPageNo)
    }
    if (from.query.rentPageNo != null) {
      store.commit('pagehistory/setRentPageNo', from.query.rentPageNo)
    }
    if (from.query.msConsignmentPageNo != null) {
      store.commit('pagehistory/setMsConsignmentPageNo', from.query.msConsignmentPageNo)
    }
    if (from.query.eqConsignmentPageNo != null) {
      store.commit('pagehistory/setEqConsignmentPageNo', from.query.eqConsignmentPageNo)
    }
    next()
    return
  }
  // 权限页面，需要判定token
  const token = store.getters.token
  if (token != null && token.length > 0) {
    next()
  } else {
    next('/login')
  }
})
export default router
